import React from "react";
import axiosCoralie from "../../axios-setup";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { loadPage } from "../../utils/urlUtils";

export default function Cgu({
    setIsAppLoading,
}) {

    const CONF= window?.confPub
    const ROUTES_PAGES = CONF?.ROUTES?.PAGES

    const navigate = useNavigate()

    const {
        keycloakReduce,
    } = useSelector(state => ({
        ...state.keycloakReducer,
    }))

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsAppLoading(true)

        // const id = keycloakReduce?.decodedToken?.sub
        const email = keycloakReduce?.decodedToken?.email

        axiosCoralie.post(CONF?.ROUTES?.CORRESPONDANTS?.CGU, { email })
            .then((res) => {

                console.log('CGU res')
                console.log(res)

                loadPage(navigate, ROUTES_PAGES?.ROOT)
            }).catch(e => {

                console.log('CGU e')
                console.log(e)

                navigate(ROUTES_PAGES?.ERROR)
                setIsAppLoading(false)
            })
    }

    return (<>
        <div className="container pt-5">
            <div>
                <h1 className="mb-3">
                    <span className="blue-text">CHARTE D’UTILISATION </span>
                    <br/>
                    <span className="turquoise-text">DE L’ESPACE </span>
                    {/*<br/>*/}
                    <span className="turquoise-text">CORRESPONDANT MNH</span>
                </h1>

                <h2><span className="pink-text">1 - OBJET</span></h2>

                <p>La pr&eacute;sente charte d&rsquo;utilisation a
                    pour&nbsp; objet&nbsp; de&nbsp; d&eacute;finir&nbsp; les modalit&eacute;s et les conditions
                    d&rsquo;utilisation de l&rsquo;espace correspondant MNH (ci-apr&egrave;s &laquo; Espace &raquo;)
                    accessible depuis le site <a href="http://www.mnh.fr/coralie">http://www.mnh.fr/coralie</a></p>

                <p>Cet Espace permet &agrave; tout correspondant MNH de mettre &agrave; sa disposition des informations,
                    des documents, des outils et des services en ligne destin&eacute;s &agrave; l&rsquo;accomplissement
                    de sa mission MNH : acc&egrave;s aux dossiers des agents, annuaires, calculs, d&eacute;claration de
                    modification des dossiers des agents, demande de prestation, acc&egrave;s &agrave; la documentation
                    MNH, relation avec la MNH, &hellip;.</p>

                <p>L&rsquo;inscription du correspondant MNH &agrave; l&rsquo;Espace vaut acceptation pleine et
                    enti&egrave;re de la pr&eacute;sente charte et toute connexion &agrave; l&rsquo;Espace est
                    subordonn&eacute;e au respect de la pr&eacute;sente charte d&rsquo;utilisation.</p>

                <h2><span className="pink-text">2 - MENTIONS LEGALES</span></h2>

                <p>L&rsquo;&eacute;diteur du site <a href="http://www.mnh.fr/coralie">http://www.mnh.fr/coralie</a> est
                    la Mutuelle Nationale des Hospitaliers et des professionnels de la sant&eacute; et du social (MNH),
                    soumise aux dispositions du Livre II du code de la mutualit&eacute;, immatricul&eacute;e au
                    R&eacute;pertoire SIRENE sous le n&deg;775 606 361, et dont le si&egrave;ge social est
                    situ&eacute; : 331, avenue d&rsquo;Antibes &ndash; Amilly - 45213 MONTARGIS Cedex</p>

                <p>L&rsquo;h&eacute;bergeur du site <a
                    href="http://www.mnh.fr/coralie">http://www.mnh.fr/coralie</a> est la Mutuelle Nationale des
                    Hospitaliers et des professionnels de la sant&eacute; et du social (MNH)</p>

                <h2><span className="pink-text">3 - ACCES A L&rsquo;ESPACE</span></h2>

                <p>L&rsquo;Espace est un service ouvert exclusivement aux correspondants MNH. La MNH se r&eacute;serve
                    le droit de refuser l&rsquo;acc&egrave;s &agrave; l&rsquo;Espace &agrave; toute personne qui ne
                    respecterait pas les dispositions de la pr&eacute;sente charte d&rsquo;utilisation.</p>

                <p>L&rsquo;acc&egrave;s &agrave; l&rsquo;Espace par les correspondants MNH est
                    gratuit &agrave; condition de disposer d&rsquo;un acc&egrave;s &agrave; Internet. Tous les
                    co&ucirc;ts relatifs &agrave; l&rsquo;acc&egrave;s &agrave; l&rsquo;Espace, notamment les frais
                    mat&eacute;riels, logiciels ou d&rsquo;acc&egrave;s &agrave; internet, sont
                    exclusivement &agrave; la charge du correspondant ou de son &eacute;tablissement. Le correspondant
                    est seul responsable du bon fonctionnement de son &eacute;quipement informatique ainsi que de son
                    acc&egrave;s &agrave; internet.</p>

                <p>Pour avoir acc&egrave;s &agrave; l&rsquo;Espace, le correspondant doit s&rsquo;authentifier en
                    pr&eacute;cisant un identifiant personnel et un mot de passe qui lui
                    auront &eacute;t&eacute; communiqu&eacute;s par email ou par courrier. Le mot de passe
                    devra &ecirc;tre modifi&eacute; &agrave; la premi&egrave;re utilisation</p>

                <p>Toute tentative de recherche exhaustive d&rsquo;un login ou d&rsquo;un mot de passe entra&icirc;nera
                    le blocage temporaire du compte et sera trac&eacute;e dans les journaux de l&rsquo;Espace.</p>

                <p>Le correspondant MNH est responsable de la garde des mots de passe pour l&rsquo;acc&egrave;s et la
                    mise en &oelig;uvre des services offerts sur l&rsquo;Espace Correspondant. La MNH ne
                    pourra &ecirc;tre tenue responsable de l&rsquo;utilisation frauduleuse du mot de passe et code
                    d&rsquo;acc&egrave;s par le correspondant ou par un tiers qui serait parvenu &agrave; les
                    subtiliser.</p>

                <p>En cas d&rsquo;oubli, de perte ou de vol de son identifiant et/ou de son mot de passe, ou s&rsquo;il
                    prend connaissance de l&rsquo;utilisation de son mot de passe et de son code d&rsquo;acc&egrave;s
                    par un tiers non autoris&eacute;, le correspondant doit imm&eacute;diatement contacter la MNH par
                    t&eacute;l&eacute;phone au 09 69 32 45 01 ou par courriel &agrave; l&rsquo;adresse <a
                        href="mailto:correspondant@mnh.fr">correspondant@mnh.fr</a> qui lui communiquera de nouveaux
                    mots de passe et code d&rsquo;acc&egrave;s.</p>

                <p>Par la pr&eacute;sente, le correspondant s&rsquo;engage &agrave; utiliser l&rsquo;Espace et/ou de
                    proc&eacute;der &agrave; une extraction qualitativement ou quantitativement substantielle des bases
                    de donn&eacute;es mises en ligne dans l&rsquo;Espace uniquement dans le cadre de sa mission de
                    correspondant MNH et dans le strict respect des pr&eacute;sentes dispositions.</p>

                <p>Le correspondant s&rsquo;interdit d&rsquo;acc&eacute;der ou de tenter
                    d&rsquo;acc&eacute;der &agrave; des espaces virtuels auquel un acc&egrave;s ne lui aurait
                    pas &eacute;t&eacute; accord&eacute;. Toute personne naviguant sur l&rsquo;Espace est
                    consid&eacute;r&eacute;e comme &eacute;tant le correspondant identifi&eacute; en qualit&eacute; de
                    correspondant MNH.</p>

                <h2><span
                    className="pink-text">4 - OBLIGATIONS<strong> DU CORRESPONDANT MNH &ndash; UTILISATEUR</strong></span>
                </h2>

                <p>En utilisant l&rsquo;Espace, le correspondant s&rsquo;engage &agrave; respecter la pr&eacute;sente
                    charte d&rsquo;usage ainsi que les lois et r&egrave;glements en vigueur.</p>

                <p>Il s&rsquo;engage &agrave; ne pas faire preuve d&rsquo;incorrection &agrave; l&rsquo;&eacute;gard de
                    ses interlocuteurs dans les &eacute;changes.</p>

                <p>Le correspondant reconna&icirc;t le caract&egrave;re sensible de l&rsquo;ensemble des informations
                    auxquelles il a acc&egrave;s sur l&rsquo;Espace. En effet, dans le cadre de ses missions, le
                    correspondant a acc&egrave;s aux outils de la MNH contenant&nbsp; des
                    donn&eacute;es &agrave; caract&egrave;re personnel. Ainsi, il
                    s&rsquo;engage &agrave; n&rsquo;utiliser
                    les&nbsp; donn&eacute;es&nbsp; &agrave;&nbsp; caract&egrave;re&nbsp; personnel&nbsp; auxquelles&nbsp; il
                    a acc&egrave;s que conform&eacute;ment aux instructions de la MNH et exclusivement aux fins de
                    r&eacute;alisation de sa mission et&nbsp;&nbsp;&nbsp; &agrave; ne pas modifier ou
                    divulguer &agrave; quiconque, que ce soit &agrave; titre gratuit ou on&eacute;reux, les
                    donn&eacute;es &agrave; caract&egrave;re personnel auxquelles il a acc&egrave;s et informations
                    confidentielles.</p>

                <p>En cas de d&eacute;part ou de changement d&rsquo;affectation, le correspondant
                    s&rsquo;engage &agrave; le signaler &agrave; la MNH.</p>

                <p>Le correspondant doit par ailleurs signaler&nbsp; &agrave;&nbsp; la&nbsp; MNH&nbsp; tout changement
                    relatif &agrave; ses informations personnelles (adresse, t&eacute;l&eacute;phone, fax,
                    courriel&hellip;)</p>

                <p>Un formulaire est mis &agrave; sa disposition dans l&rsquo;Espace pour signaler tout changement.</p>

                <h2><span
                    className="pink-text">5 - COLLECTE DES DONNEES PERSONNELLES DU CORRESPONDANT SUR L&rsquo;ESPACE</span>
                </h2>

                <p>Les donn&eacute;es personnelles recueillies dans le cadre de sa mission de correspondant MNH sont
                    n&eacute;cessaires pour l&rsquo;inscription du
                    correspondant&nbsp; sur&nbsp; l&rsquo;Espace,&nbsp; la&nbsp; gestion&nbsp; de son statut de
                    correspondant et de l&rsquo;Espace et tous les traitements y aff&eacute;rent.</p>
            </div>

            <p>Elles sont destin&eacute;es &agrave; la MNH et &agrave; MNH Pr&eacute;voyance, responsables des
                traitements, ainsi qu&rsquo;&agrave; leurs &eacute;ventuels sous-traitants, prestataires techniques,
                partenaires contractuels et &agrave; toutes personnes morales qui leurs sont affili&eacute;es au sens
                des articles L.233-1 et suivants du Code de Commerce et &agrave; l&rsquo;article L356-1 du Code des
                Assurances.</p>

            <p>Conform&eacute;ment &agrave; la loi Informatique et Libert&eacute;s du 6 janvier 1978 modifi&eacute;e, le
                correspondant dispose d&rsquo;un droit d&rsquo;acc&egrave;s et de rectification des donn&eacute;es le
                concernant ainsi que d&rsquo;un droit d&rsquo;opposition pour motif l&eacute;gitime, droits qu&rsquo;il
                peut exercer par demande &eacute;crite aupr&egrave;s de la MNH, par mail &agrave; l&rsquo;adresse <a
                    href="mailto:correspondant@mnh.fr">correspondant@mnh.fr</a> ou par courrier &agrave; l&rsquo;adresse
                MNH - P&ocirc;le des correspondants - 331 avenue d&rsquo;Antibes - 45200 Amilly.</p>

            <h2><span className="pink-text">6 - PROPRIETE INTELLECTUELLE</span></h2>

            <p>La structure g&eacute;n&eacute;rale de l&rsquo;Espace, ainsi que les textes, graphiques, images,
                sons&nbsp; et&nbsp; vid&eacute;os&nbsp; la&nbsp; composant,&nbsp; sont&nbsp; la
                propri&eacute;t&eacute; de la MNH ou de ses partenaires. Toute repr&eacute;sentation et/ou reproduction
                et/ou exploitation partielle ou totale des contenus et services propos&eacute;s, par quelque
                proc&eacute;d&eacute; que ce soit, sans l&rsquo;autorisation pr&eacute;alable et par &eacute;crit de MNH
                et/ou de ses partenaires est strictement interdite et serait susceptible de constituer une
                contrefa&ccedil;on au sens des articles L. 335-2 et suivants du Code de la
                propri&eacute;t&eacute; intellectuelle.</p>

            <h2><span className="pink-text">7 - DISPONIBILIT&Eacute; DE L&rsquo;ESPACE</span></h2>

            <p>La MNH s&rsquo;efforce de permettre l&rsquo;acc&egrave;s &agrave; l&rsquo;Espace 24 heures sur 24, 7
                jours sur 7. Toutefois, le correspondant reconna&icirc;t que les informations et services
                propos&eacute;s dans l&rsquo;Espace pourront:</p>

            <ul>
                <li>&ecirc;tre interrompus pour des cas de force majeure ou des &eacute;v&egrave;nements
                    ind&eacute;pendants de la volont&eacute; de la MNH&nbsp;&nbsp; ou des faits ne relevant pas de la
                    responsabilit&eacute; de la MNH ou des &eacute;ventuelles pannes et interventions de maintenance
                    n&eacute;cessaires au bon fonctionnement de l&rsquo;Espace,
                </li>
                <li>contenir des erreurs de nature technique ou humaine,</li>
                <li>induire des pertes de donn&eacute;es ponctuelles.</li>
            </ul>

            <p>Le correspondant MNH reconna&icirc;t que, nonobstant&nbsp; tous les moyens mis en &oelig;uvre par la MNH,
                l&rsquo;internet pr&eacute;sente des sp&eacute;cificit&eacute;s techniques qui impliquent
                l&rsquo;impossibilit&eacute; pour la MNH de garantir la continuit&eacute; absolue de
                l&rsquo;acc&egrave;s au service et des temps de r&eacute;ponse, ainsi que la s&eacute;curit&eacute; dans
                la transmission des donn&eacute;es.</p>

            <p>La responsabilit&eacute; de MNH ne saurait &ecirc;tre engag&eacute;e en cas
                d&rsquo;impossibilit&eacute; d&rsquo;acc&egrave;s &agrave; ce site et/ou d&rsquo;utilisation des
                services.</p>

            <p>Par ailleurs, la MNH est libre de faire &eacute;voluer, de modifier ou de suspendre, sans pr&eacute;avis,
                l&rsquo;Espace pour des raisons de maintenance ou tout autre motif jug&eacute; utile.
                L&rsquo;indisponibilit&eacute; ou les incidents dans le fonctionnement du site ou des services ne donne
                droit &agrave; aucune garantie ni indemnit&eacute; et/ ou dommages-int&eacute;r&ecirc;ts d&rsquo;aucune
                sorte. Le correspondant reconna&icirc;t et accepte que la MNH ne soit pas responsable des interruptions
                et des cons&eacute;quences qui peuvent en d&eacute;couler pour le correspondant ou tout tiers.</p>

            <p>En cas de non-respect par un correspondant de la&nbsp; pr&eacute;sente charte d&rsquo;utilisation ou des
                dispositions l&eacute;gales
                et/ou&nbsp; r&egrave;glementaires&nbsp; applicables,&nbsp; la&nbsp; MNH&nbsp; se&nbsp; r&eacute;serve &nbsp;le</p>

            <p>droit d&rsquo;interrompre, de suspendre, temporairement ou d&eacute;finitivement, l&rsquo;acc&egrave;s et
                l&rsquo;utilisation par cet utilisateur de l&rsquo;Espace.</p>

            <p>La suspension ou l&rsquo;arr&ecirc;t de la mission du correspondant entra&icirc;ne obligatoirement et
                sans recours la suspension ou l&rsquo;arr&ecirc;t de l&rsquo;Espace rattach&eacute;.</p>

            <h2><span className="pink-text">8 - COOKIES</span></h2>

            <p>Un cookie est un petit fichier texte au format alphanum&eacute;- rique d&eacute;pos&eacute; sur le disque
                dur de l&rsquo;internaute par le serveur du site visit&eacute; ou par un serveur tiers permettant au
                serveur du site visit&eacute; de r&eacute;cup&eacute;rer des donn&eacute;es d&rsquo;ordre statistique.
                L&rsquo;Espace correspondant utilise des traceurs (cookies afin de r&eacute;aliser des statistiques
                anonymes de visites et de mesurer l&rsquo;activit&eacute; du correspondant au regard des missions qui
                lui sont confi&eacute;es). Ainsi, la MNH est susceptible d&rsquo;acc&eacute;der &agrave; des
                informations d&eacute;j&agrave; stock&eacute;es dans l&rsquo;&eacute;quipement terminal de
                communications &eacute;lectroniques utilis&eacute; pour se connecter et d&rsquo;y inscrire des
                informations. L&rsquo;usage de ces cookies ne permet aucun recueil de donn&eacute;es personnelles.</p>

            <p>L&rsquo;utilisateur peut refuser l&rsquo;utilisation de cookies</p>

            <h2><span className="pink-text">9 - MODIFICATION<strong> DE LA CHARTE D&rsquo;UTILISATION</strong></span>
            </h2>

            <p>La MNH se r&eacute;serve la possibilit&eacute; de modifier, &agrave; tout moment et sans pr&eacute;avis,
                la pr&eacute;sente charte d&rsquo;utilisation en fonction des modifications apport&eacute;es au service,
                de l&rsquo;&eacute;volution de&nbsp; la l&eacute;gislation ou pour tout autre motif
                jug&eacute; n&eacute;cessaire. Il appartient au correspondant de s&rsquo;informer des termes de la
                pr&eacute;sente charte dont seule la version accessible en ligne est r&eacute;put&eacute;e en
                vigueur.</p>

            <h2><span className="pink-text">10 - DUREE</span></h2>

            <p>La dur&eacute;e de la pr&eacute;sente charte d&rsquo;utilisation est ind&eacute;termin&eacute;e. Elle
                produit ses effets &agrave; l&rsquo;&eacute;gard du correspondant &agrave; compter de sa premi&egrave;re
                identification.</p>

            <h2><span className="pink-text">11 - DROIT APPLICABLE</span></h2>

            <p>La pr&eacute;sente charte d&rsquo;utilisation de l&rsquo;Espace ainsi que l&rsquo;ensemble des documents
                mis &agrave; disposition sur l&rsquo;Espace seront pour leur validit&eacute;, leur interpr&eacute;tation
                et leur ex&eacute;cution soumis &agrave; la loi fran&ccedil;aise.</p>

            <h2><span className="pink-text">12 - LITIGES</span></h2>

            <p>Les litiges auxquels pourraient donner lieu l&rsquo;Espace ainsi que les documents qui sont
                mis &agrave; disposition seront de la comp&eacute;tence exclusive des Tribunaux civils du ressort du
                d&eacute;fendeur.</p>

            <p>&nbsp;</p>

            <p><u><em>Pour toute question relative &agrave; la pr&eacute;sente charte d&rsquo;utilisation, le
                correspondant peut contacter la MNH &agrave; l&rsquo;adresse suivante : 331 avenue
                d&rsquo;Antibes &ndash; 45200 Amilly.</em></u></p>

        </div>
        <div className="d-flex justify-content-center">
            <button type="submit" className="btn btn-primary center" onClick={ handleSubmit }>Accepter</button>
        </div>
    </>)
}